import { EMPTY_STRING } from "shared/constants";
import { IFormInput } from "./types";

export const defaultValues: IFormInput = {
  businessUnitId: null,
  clientLead: EMPTY_STRING,
  processManager: EMPTY_STRING,
};
